import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const bankingServicesAnalysisSlice = createApi({
  reducerPath: "analysis_banking_services",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["banking_services"],
  endpoints: (build) => ({
    getBankingServicesSummary: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/banking_services/summary`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),
    getBankingServicesExpanded: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/banking_services/expand`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),
  }),
});

export const { useGetBankingServicesSummary, useGetBankingServicesExpanded } =
  bankingServicesAnalysisSlice;
